<div class="default-dialog-layout dialog-with-max-width">
    <div class="title">Are you sure you want to delete this {{ data.type }}?</div>

    <div class="content">
        <ng-container *ngIf="data.type === 'folder'">
            <cds-alert-group
                status="warning"
                type="light"
                aria-label="All contained datasets and sub-folders will be deleted as well"
            >
                <cds-alert
                    >All contained datasets and sub-folders will be deleted as well</cds-alert
                >
            </cds-alert-group>
        </ng-container>

        <div class="node-name">
            <ng-container *ngIf="data.type === 'folder'; else fileIconBlock">
                <cds-icon shape="folder" [solid]="true" status="info"></cds-icon>
            </ng-container>
            <ng-template #fileIconBlock>
                <cds-icon shape="file" [solid]="true" status="neutral"></cds-icon>
            </ng-template>
            <span>{{ data.name }}</span>
        </div>
    </div>

    <div class="actions action-buttons">
        <cds-button size="sm" action="flat" (click)="onCancel()">Cancel</cds-button>
        <cds-button size="sm" (click)="onConfirm()">Delete</cds-button>
    </div>
</div>
